import React from 'react';
import { IContainerReactRenderer, IRendererResult } from './IContainerReactRenderer';
import { TextContainer } from '../../model/containers/TextContainer';
import { PiChatAnswer } from 'features/pi/view/uiManager/text-instances/pi-chat-answer/pi-chat-answer';
import { IConversationRun } from '../../model/ConversationRun';

export class TextContainerRenderer implements IContainerReactRenderer<TextContainer> {
    render(run: IConversationRun ,container: TextContainer): IRendererResult {
        return { content: <PiChatAnswer run={run} text={container.data.get()} /> };
    }
}
